import { User, UserCog, LogOut } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const UserDropdown: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleProfileClick = () => {
    navigate("/dashboard/settings?tab=profile");
    setIsDropdownOpen(false);
  };

  const handlePermissionsClick = () => {
    navigate("/dashboard/settings?tab=permissions");
    setIsDropdownOpen(false);
  };

  const handleTeamsClick = () => {
    navigate("/dashboard/settings?tab=teams");
    setIsDropdownOpen(false);
  };

  const handleLogout = () => {
    // Clear all localStorage items
    localStorage.clear();

    // Redirect to login page
    navigate("/login");
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        className="w-8 h-8 rounded-full bg-white flex items-center justify-center text-green-600 hover:bg-gray-100"
      >
        <User size={20} />
      </button>

      {isDropdownOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-10 py-1 border border-gray-200">
          <button
            onClick={handleProfileClick}
            className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-left"
          >
            <User size={16} className="mr-2" />
            Profile
          </button>
          <button
            onClick={handleTeamsClick}
            className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-left"
          >
            <User size={16} className="mr-2" />
            Teams
          </button>
          <button
            onClick={handlePermissionsClick}
            className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-left"
          >
            <UserCog size={16} className="mr-2" />
            Permissions
          </button>
          <div className="border-t border-gray-200 my-1"></div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-left"
          >
            <LogOut size={16} className="mr-2" />
            Log Out
          </button>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;
